import { render, staticRenderFns } from "./CheckboxNew.vue?vue&type=template&id=589d342b&scoped=true"
import script from "./CheckboxNew.vue?vue&type=script&lang=js"
export * from "./CheckboxNew.vue?vue&type=script&lang=js"
import style0 from "./CheckboxNew.vue?vue&type=style&index=0&id=589d342b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d342b",
  null
  
)

export default component.exports